import { get } from 'lodash';
import React from 'react';
import { withComponentName } from '../../common/ComponentNameContext';
import SearchFilter from '../../common/search-filter/SearchFilter';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { TYPE_DISABLE } from '../../common/sync-component/Const';
import { syncComponentSelector } from '../../helpers/Common';
import EventEmitter, {
  SYNC_COMPONENT_SEARCH,
} from '../../helpers/EventEmitter';
import { changeCode, REDUCER_NAME } from './reducer';
import { withComponentId } from './../../common/ComponentIdContext';
import { REDUCER_NAME as COMMON_REDUCER_NAME } from './../../app/commonReducer';

const getListSearchFromRedux = state => [
  ...state[COMMON_REDUCER_NAME].listOrganizationSearch,
  ...state[COMMON_REDUCER_NAME].listDerivative,
  ...state[COMMON_REDUCER_NAME].listCoveredWarrant,
];

class Search extends React.Component {
  clickItemSearch = currentSearch => {
    const { changeCode, componentId, syncType } = this.props;
    changeCode(currentSearch, componentId);
    if (syncType === TYPE_DISABLE) {
      return;
    }
    EventEmitter.dispatch(SYNC_COMPONENT_SEARCH, {
      componentId,
      syncType: syncType,
      search: currentSearch,
    });
  };

  render() {
    const {
      condition,
      listOrganizationByOrganCode,
      listDerivativeByDerivativeCode,
      coveredWarrantDataByCode,
    } = this.props;

    return (
      <SearchFilter
        schema={[
          { key: 'displayCode', className: 'w-20' },
          {
            key: 'codeName',
            className: item =>
              `${item.exchange ? 'w-55' : 'w-80'} text-truncate`,
          },
          {
            key: 'exchange',
            className: 'w-25 text-right',
            render: text => text.toUpperCase(),
          },
        ]}
        listKeyFilter={['displayCode', 'codeName']}
        getListSearchFromRedux={getListSearchFromRedux}
        currentSearch={
          {
            ...listOrganizationByOrganCode,
            ...listDerivativeByDerivativeCode,
            ...coveredWarrantDataByCode,
          }[condition.code] || condition
        }
        mainKey={'code'}
        sortKey={'displayCode'}
        clickItemSearch={this.clickItemSearch}
      />
    );
  }
}

const mapStateToProps = (state, { componentId, componentName }) => {
  return {
    condition: state[REDUCER_NAME].listMultiComponent[componentId].condition,
    listOrganizationByOrganCode:
      state[COMMON_REDUCER_NAME].listOrganizationByOrganCode,
    listDerivativeByDerivativeCode:
      state[COMMON_REDUCER_NAME].listDerivativeByDerivativeCode,
    coveredWarrantDataByCode:
      state[COMMON_REDUCER_NAME].coveredWarrantDataByCode,
    syncType: syncComponentSelector(state, componentName, componentId),
  };
};

const mapDispatchToProps = {
  changeCode,
};

export default compose(
  withComponentId,
  withComponentName,
  connect(
    mapStateToProps,
    mapDispatchToProps,
  ),
)(Search);
